import { render } from "./FilePicker.vue?vue&type=template&id=fec4a3ba&scoped=true"
import script from "./FilePicker.vue?vue&type=script&lang=js"
export * from "./FilePicker.vue?vue&type=script&lang=js"

import "./FilePicker.vue?vue&type=style&index=0&id=fec4a3ba&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fec4a3ba"]])

export default __exports__
import QUploader from 'quasar/src/components/uploader/QUploader.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QUploader});
